var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "land-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "land-icon",
    stroke: "#000000",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0.282352941 15.7725176 15.7722353 15.7725176 15.7722353 0.282635294 0.282352941 0.282635294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18447059,12.8313412 L3.18447059,4.98851765",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    points: "2.13025882 6.01242353 3.18908235 4.9536 4.26767059 6.03218824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18447059,12.8313412 L11.0272941,12.8313412",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    points: "9.98823529 11.7918118 11.0470588 12.8506353 9.96847059 13.9292235"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandIcon);
export default __webpack_public_path__ + "static/media/land-icon.8c3dce8951a96147ed32a01e7af4c9c7.svg";
export { ForwardRef as ReactComponent };